import { Button } from '@daily/shared/components/Button';
import { Modal } from '@daily/shared/components/Modal';
import { Text } from '@daily/shared/components/Text';
import { useLocalSessionId } from '@daily-co/daily-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { isMediaElementPlaying } from '../../lib/dom';
import { captureAudioPlayException } from '../../lib/sentry-capture-helpers';

interface Props extends React.ComponentProps<typeof Modal> {}

export const AutoplayFailedModal: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  const { t } = useTranslation();

  const localSessionId = useLocalSessionId();

  const handleModalClose = useCallback(() => {
    document
      .querySelectorAll('.audioTracks audio')
      .forEach((audio: HTMLAudioElement) => {
        const playAudio = () => {
          const promise = audio.play();
          if (promise !== undefined) {
            promise
              .then(() => {
                // All good, audio is playing
              })
              .catch((error) => {
                // Audio play still failing
                console.warn('Failed to play audio', error);
                captureAudioPlayException(error, audio, localSessionId, {
                  autoplayFailedModal: 1,
                });
              });
          }
        };
        if (!isMediaElementPlaying(audio)) playAudio();
      });
    props.onClose();
  }, [localSessionId, props]);

  return (
    <Modal
      actions={[
        <Button id="autoplay-failed-join" key="join" variant="primary">
          {t('general.joinMeeting')}
        </Button>,
      ]}
      onClose={handleModalClose}
      title={t('lobby.audioPrompt.title')}
    >
      <Text El="p" variant="large">
        {t('lobby.audioPrompt.desc')}
      </Text>
    </Modal>
  );
};
